import { css } from 'styled-components';

export const mixinTextXSmall = css`
    font-size: var(--font-size-xsmall);
    line-height: var(--line-height-xsmall);
`;

export const mixinTextSmall = css`
    font-size: var(--font-size-small);
    line-height: var(--line-height-small);
`;

export const mixinTextBase = css`
    font-size: var(--font-size-regular);
    line-height: var(--line-height-regular);
`;
